var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$apollo.queries.getGeofencebyId.loading)?_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"danger","label":"Spinning"}},[_vm._v("Cargando")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }